import React from 'react';
import Reflux from 'reflux';
import Modal from 'shared/components/misc/modal.jsx';
import { Row, Col, Input, ButtonInput } from 'bootstrap';
import GlobalElementStore from 'shared/flux/stores/GlobalElementStore';
import CuesheetStore from 'shared/flux/stores/cuesheet/CuesheetStore';
import SimpleInputColorPicker from 'shared/components/pickers/simpleInputColorPicker';
import HexColorConstants from 'shared/constants/HexColors';
import TagFormActions from 'shared/flux/actions/TagFormActions';

/**
 * Keyboard Shortcuts Modal
 */
export default React.createClass({
  mixins: [
    Reflux.ListenerMixin,
    Reflux.connect(GlobalElementStore, 'globalElement'),
    Reflux.connect(CuesheetStore, 'cuesheet'),
  ],

  displayName: 'CreateLabelModal',

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  propTypes: {
    teamId: React.PropTypes.string,
    eventId: React.PropTypes.string,
    defaultText: React.PropTypes.string,
    onCreateCompleted: React.PropTypes.string,
  },

  getInitialState() {
    return {};
  },

  componentWillMount() {
    this.listenTo(TagFormActions.create.completed, 'onTagCreateCompleted');
  },

  componentDidMount() {
    this.setState({
      text: this.props.defaultText,
      color: HexColorConstants[0],
    });
  },

  render() {
    const { modalId } = this.props;
    // const { publishState, globalElement } = this.state;

    return (
      <Modal
        className="modal-generic-wrapper ge-create-tag-modal"
        headerClassName="modal-generic-header"
        name={modalId}
        modalType={modalId}
        title="Create new tag"
        onHide={() => {}}
        autoFocus={false}
      >
        <div>
          <Row>
            <Col md={12}>
              <Input
                label="Tag name"
                type="text"
                placeholder="Tag name..."
                value={this.state.text}
                onChange={(e) =>
                  this._handleInputChange('text', e.target.value)
                }
              />
            </Col>
            <Col md={12}>
              <SimpleInputColorPicker
                label="Tag color"
                popoverId={`${modalId}-color-picker`}
                defaultHexColors={HexColorConstants}
                onChange={(hexColor) =>
                  this._handleInputChange('color', hexColor)
                }
                activeHexColor={this.state.color}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <ButtonInput
                onClick={this._handleCreate}
                value="Create tag"
                className="btn-create-tag"
                bsSize="md"
                bsStyle="primary"
              />
            </Col>
          </Row>
        </div>
      </Modal>
    );
  },

  _handleInputChange(field, value) {
    this.setState({ [field]: value });
  },

  _handleCreate() {
    const { teamId, eventId } = this.props;
    const { text, color } = this.state;

    TagFormActions.create(teamId, eventId, { text, color });
  },

  onTagCreateCompleted(event) {
    const { text } = this.state;
    const { onCreateCompleted } = this.props;

    const tag = event.globalElementLabels.find((label) => {
      return label.text === text;
    });

    onCreateCompleted(tag);
  },
});
